import React, { ChangeEvent } from 'react'
import _ from 'lodash'
import { ISupplyDataVariant } from '@components/Product/VariantKitPanel/VariantKitPanel'

interface Props {
  variants: ISupplyDataVariant[]

  onChange(e: ChangeEvent): void

  selected: number | null
}

const parseValues = (attributes: ISupplyDataVariant['attributes']) => {
  let values = ''
  _.forIn(attributes, val => {
    values += `${val} `
  })
  return values.trim()
}

// Single variant: plain text. Multiple variants: a select styled like the quantity field next to it.
const VariantsSelect: React.FC<Props> = ({ variants, onChange, selected }) => {
  if (variants.length === 1) {
    const [variant] = variants
    const text = parseValues(variant.attributes) || variant.variantName
    return text ? <span className='text-sm block truncate mt-4'>{text}</span> : null
  }

  return (
    <select
      value={selected}
      onChange={onChange}
      className='w-full h-[36px] px-10 mt-4 border border-solid border-gray-400 rounded-lg bg-white text-sm'
    >
      {variants.map(variant => {
        let values = parseValues(variant.attributes)
        if (variant.id.toString() === 'click-select') {
          values = variant.variantName || values
        }
        return (
          <option key={variant.supplyVariantPk} value={variant.supplyVariantPk}>
            {values}
          </option>
        )
      })}
    </select>
  )
}

export default VariantsSelect
